exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-image[data-v-16c6dadc]{height:3rem;width:auto;flex:none;flex-shrink:0;background-position:50%;background-size:cover;background-repeat:no-repeat}.logo-wrapper[data-v-16c6dadc]{display:flex;flex-direction:row;align-items:center;margin-right:.375rem;justify-content:flex-start;cursor:pointer}.logo-wrapper.large .logo-image[data-v-16c6dadc]{height:3rem}.logo-wrapper.small .logo-image[data-v-16c6dadc]{height:1.125rem}", ""]);

// exports
